import {RANGE_MOBILE, viewportRange} from '../../context/SidebarContext';

/**
 * El alta en el celular (UD-23 de `/ux`, revisada el 01/11).
 *
 * 16 de las 20 altas del 16 al 31/10 llegaron desde el celular y casi ninguna pasó de «Conecta tus
 * plataformas», sin errores. La primera versión (31/10) ponía arriba «Desde la computadora es más
 * fácil» con «Mandarme el link» y llevaba la salida a «Sigues desde la computadora». fede la dio
 * vuelta el 01/11 («quizás en ese momento no puede»): quien llega desde Instagram puede no tener una
 * computadora por horas, y mandarlo a otro lado es perderlo. En 2 altas con esa versión, nadie tocó
 * el botón.
 *
 * Hoy: conectar desde el teléfono es el camino principal (las tarjetas dicen con qué cuenta entrar),
 * y para quien no tiene la cuenta a mano hay una línea DEBAJO de las tarjetas que dice lo que ya
 * pasó: el correo de bienvenida del motor (P0) sale en el segundo del alta con el link a este paso.
 * ⚠️ Esa frase es verdad mientras el motor de seguimiento esté prendido y P0 lleve el link: si eso
 * cambia, cambia el texto (`onboarding.mobile.later_note` y `saved_body`).
 */

// La ruta y su nombre de pantalla (`onboarding_mobile_continue`) se conservan desde la primera versión
// para que la medición de UD-23 siga siendo la misma; la pantalla ahora dice «Guardamos tu avance».
export const CONTINUE_PATH = '/onboarding/seguir-en-la-computadora';
export const PLATFORMS_PATH = '/onboarding/plataformas';

// Van como pantalla en `UserScreenActivity` (`SCREEN_NAME_REGEX` del backend: snake_case, 3 a 64).
// `note_shown` es la línea de la versión del 01/11; `link_shown` y `link_share` eran de la del 31/10.
export const MOBILE_EVENTS = {
    noteShown: 'onboarding_mobile_note_shown',
    exit: 'onboarding_mobile_exit_continue',
    demo: 'onboarding_mobile_demo',
};

/** El mismo corte que usa el marco de la app para su versión de celular (< 768 px). */
export function isPhoneViewport(width = window.innerWidth) {
    return viewportRange(width) === RANGE_MOBILE;
}
